import React from 'react'
import styled from '@emotion/styled'
import { pinIcon } from 'view/components/datagrid/styles/gridIconSet'
import { CORE_PRIMARY_4 } from 'view/styles/constants'
import { CustomCellRendererProps } from 'ag-grid-react'
import { isFirstCollateralRow } from './utils'
import { InflightNegotiations } from 'api'

interface IconProps {
  className?: string
  color?: string
  size?: string | number
  rotate?: number
  isHidden?: boolean
}

const Icon = styled.div<IconProps>`
  ${({ color }) => color && `color: ${color};`}
  ${({ isHidden }) => isHidden && `visibility: hidden;`}
  svg {
    ${({ size }) => size && `width: ${size};`}
    ${({ size }) => size && `height: ${size};`}
    ${({ rotate }) => rotate && `transform: rotate(${rotate}deg);`}
  }
`

export const PinnedCollateralIcon = (props: IconProps & CustomCellRendererProps<InflightNegotiations>) => {
  const isPinned = props.context?.userPreference?.pinnedCollaterals?.includes(props?.node?.data?.collateral?.id ?? '')

  return (
    <Icon
      data-test-id={`PinnedCollateralIcon-${props?.node?.data?.collateral?.name}`}
      color={CORE_PRIMARY_4}
      isHidden={!isPinned || !isFirstCollateralRow(props)}
      rotate={315}
      size={'15px'}>
      {pinIcon}
    </Icon>
  )
}
